// Dependencias generales
import React from "react";
import { useEffect, useState } from 'react'
import InitialConfigHeader from '../../../components/InitialConfig/UserInitialConfigHeader'
import StepIntro from '../../../components/InitialConfig/StepIntro'
import Loader from '../../../components/Utils/Loader'
import WorkflowNavigationButtons from '../../../components/InitialConfig/WorkflowNavigationButtons'
import WorkflowIlustration from "../../../components/InitialConfig/WorkflowIlustration"
import ReactGA from "react-ga4";

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const postInitialConfigDevicesList = endpointHelias+'/Helias/V0/Configuration/postInitialConfigDevicesList'
const updateInstallationConfiguration = endpointHelias+"/Helias/V0/Configuration/updateInstallationConfiguration"
const getHelias3pCredentials = endpointHelias+'/3rdParty/V0/Credentials/getHelias3pCredentials'
const getInstallationConfiguration = endpointHelias+"/Helias/V0/Configuration/getInstallationConfiguration"

var initialConfigCommonJS = require("../../../js/initialConfigCommon.js")
var generalCommonJS = require("../../../js/generalCommon.js")

// Initial config - Messaging
const Messaging = () => {

  useEffect(() => {    
    
    if(initialConfigCommonJS.antiBackOnboarding() === false){

      initialConfigCommonJS.actualizarPasoWorkflowEnBBDD("MESSAGING_USER")    

      if(localStorage.getItem("currentInstallationConfiguration") !== null){        
        procesarConfiguracionActual(JSON.parse(localStorage.getItem("currentInstallationConfiguration")))
      }
      else{
        cargarConfiguracionActualPaso()        
      }

      //comprobarEstadoRegistroMensajeria()

      if(localStorage.getItem("installationConfigurationMode") !== null){
        document.getElementById("messaging").className = "step"
        initialConfigCommonJS.visibilidadModoConfiguracion()
        document.getElementById("initialConfigBreadcrumb").className = document.getElementById("initialConfigBreadcrumb").className.replaceAll(" hidden", "") + " hidden"
      }
      else{
        document.title = "HELIAS - Configuración inicial: Mensajería"
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'REGISTRO', 'REGISTRO - MENSAJERÍA', "", "")
      }
      
    }

  }, []);

  const [illustrationElements, setIllustrationElements] = useState([])

  function procesarConfiguracionActual(jsonRespuesta){

    setIllustrationElements(initialConfigCommonJS.cargaInicialIlustracion(jsonRespuesta))

    //Si no hay datos configurados entonces no hago nada

    if(localStorage.getItem("installationConfigurationMode") !== null){
      document.getElementById("emailUsuario").value = jsonRespuesta.Messaging.email
      document.getElementById("emailUsuarioCabecera").innerHTML = '<span class="material-icon">email</span>' + jsonRespuesta.Messaging.email
    }
    else{
      document.getElementById("emailUsuario").value = generalCommonJS.obtenerEmailUsuario()
      document.getElementById("emailUsuarioCabecera").innerHTML = '<span class="material-icon">email</span>' + generalCommonJS.obtenerEmailUsuario()
    }           


    //Notificaciones Criticas
    try{
      if( (jsonRespuesta.Messaging.CriticalNotifications === "true") || (jsonRespuesta.Messaging.CriticalNotifications === undefined) ){
        document.getElementById("checkboxNotificacionesCriticas").checked = true
      }
      else{
        document.getElementById("checkboxNotificacionesCriticas").checked = false
      }
    }
    catch(error){
      document.getElementById("checkboxNotificacionesCriticas").checked = true
    }

    //Notificaciones Importantes
    try{
      if( (jsonRespuesta.Messaging.ImportantNotifications === "true") || (jsonRespuesta.Messaging.ImportantNotifications === undefined) ){
        document.getElementById("checkboxNotificacionesImportantes").checked = true
      }
      else{
        document.getElementById("checkboxNotificacionesImportantes").checked = false
      }
    }
    catch(error){
      document.getElementById("checkboxNotificacionesImportantes").checked = true
    }

    //Notificaciones Sugerencias
    try{
      if( (jsonRespuesta.Messaging.SuggestionsNotifications === "true") || (jsonRespuesta.Messaging.SuggestionsNotifications === undefined) ){
        document.getElementById("checkboxNotificacionesSugerencias").checked = true
      }
      else{
        document.getElementById("checkboxNotificacionesSugerencias").checked = false
      }
    }
    catch(error){
      document.getElementById("checkboxNotificacionesSugerencias").checked = true
    }

    //Notificaciones Dispositivos
    try{
      if( (jsonRespuesta.Messaging.DevicesNotifications === "true") || (jsonRespuesta.Messaging.DevicesNotifications === undefined) ){
        document.getElementById("checkboxNotificacionesActividadDispositivos").checked = true
      }
      else{
        document.getElementById("checkboxNotificacionesActividadDispositivos").checked = false
      }
    }
    catch(error){
      document.getElementById("checkboxNotificacionesActividadDispositivos").checked = true
    }

    //Notificaciones Informe Semanal
    try{
      if( (jsonRespuesta.Messaging.WeeklyReport === "true") || (jsonRespuesta.Messaging.WeeklyReport === undefined) ){
        document.getElementById("checkboxInformeSemanal").checked = true
      }
      else{
        document.getElementById("checkboxInformeSemanal").checked = false
      }
    }
    catch(error){
      document.getElementById("checkboxInformeSemanal").checked = true
    }

    //Notificaciones Informe Mensual
    /*
    try{
      if( (jsonRespuesta.Messaging.MonthlyReport === "true") || (jsonRespuesta.Messaging.MonthlyReport === undefined) ){
        document.getElementById("checkboxInformeMensual").checked = true
      }
      else{
        document.getElementById("checkboxInformeMensual").checked = false
      }
    }
    catch(error){
      document.getElementById("checkboxInformeMensual").checked = true
    }
    */

    //Notificaciones Horario no molestar
    try{
      if(jsonRespuesta.Messaging.DontDistrubTimeframe === "true"){
        document.getElementById("checkboxHorarioNoMolestar").checked = true
        document.getElementById("divHorasNoMolestar").className = document.getElementById("divHorasNoMolestar").className.replaceAll(" hidden", "")
      }
      else{
        document.getElementById("checkboxHorarioNoMolestar").checked = false
        document.getElementById("divHorasNoMolestar").className = document.getElementById("divHorasNoMolestar").className.replaceAll(" hidden", "") + " hidden"
      }
    }
    catch(error){
      document.getElementById("checkboxHorarioNoMolestar").checked = false
      document.getElementById("divHorasNoMolestar").className = document.getElementById("divHorasNoMolestar").className.replaceAll(" hidden", "") + " hidden"
    }

    //Notificaciones Horario no molestar - Hora desde
    try{              
      document.getElementById("horaDesde").value = jsonRespuesta.Messaging.DontDistrubTimeframeFrom
    }
    catch(error){
      document.getElementById("horaDesde").value = "00:00"
    }

    //Notificaciones Horario no molestar - Hora hasta
    try{              
      document.getElementById("horaHasta").value = jsonRespuesta.Messaging.DontDistrubTimeframeTo
    }
    catch(error){
      document.getElementById("horaHasta").value = "00:00"
    }

    // Email Alexa

    if(jsonRespuesta.Messaging.emailAlexa !== undefined){
      document.getElementById("emailAlexa").value = jsonRespuesta.Messaging.emailAlexa
    }
    else{
      document.getElementById("emailAlexa").value = ""
    }
 
  }

  function cargarConfiguracionActualPaso(){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")    
  
    //Petición de datos para el paso actual
    var jsonPeticion = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": ongoingInstallationConfigurationID,
      "GeneralInfo": "",
      "Meteo": "",
      "FV": "",
      "Battery": "",
      "Generator": "",
      "Cars": "",
      "Messaging": ""
    }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", getInstallationConfiguration, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)
          if(jsonRespuesta.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{    
            procesarConfiguracionActual(jsonRespuesta.body)  
            console.log("Información cargada correctamente")
          }
        }
  
        if (this.readyState === 4 && this.status !== 200) {  
          initialConfigCommonJS.mostrarMensajeInformativo('Se produjo un error al cargar la configuracion.',"negative")
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
        }
      }
      xhttp.send(data);      
  }

  function comprobarEstadoRegistroMensajeria(){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")    
  
    //Petición de datos para el paso actual
    var jsonPeticion = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": ongoingInstallationConfigurationID    
    }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", getHelias3pCredentials, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)
          if(jsonRespuesta.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{          
  
            var objRespuestaCuentasExistentes = jsonRespuesta.body
            
            if(objRespuestaCuentasExistentes.length > 0){ //Ya tengo aplicaciones registradas
              
              for (var i = 0; i < objRespuestaCuentasExistentes.length; i++) {
  
                if(objRespuestaCuentasExistentes[i].Aplicacion === "TELEGRAM"){
                  document.getElementById("fieldsetRegistroTelegram").style = "display: none"
                  document.getElementById("fieldsetYaRegistradoTelegram").style = "display"                  
                  document.getElementById("divTelegramTxt").innerHTML = objRespuestaCuentasExistentes[i].Usuario+', ya te tengo en mi agenda de Telegram!'
                  
                  if(localStorage.getItem("installationConfigurationMode") !== null){
                    document.getElementById("botonContinuar").className += " hidden"
                  }
                  
                }              
  
              }
            }
            
            //Si no lo tengo en la agenda dejo el formulario como está
  
            console.log("Información cargada correctamente")
          }
        }
  
        if (this.readyState === 4 && this.status !== 200) {                          
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
        }
      }
      xhttp.send(data);      
  }
  
  function registrarUsuarioTELEGRAM(){
  
      var usuario = document.getElementById("nombreUsuarioTelegram").value
  
      usuario = usuario.replace("@", "");
  
      if(usuario !== ""){
    
        var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
        var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
        var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")  
    
        document.getElementById("loaderMessaging").className="loader overlay"

        //Registro la cuenta de TELEGRAM
        var xhttp = new XMLHttpRequest();
        xhttp.open("POST", postInitialConfigDevicesList, true);        
        xhttp.setRequestHeader('Content-Type', "application/json");
        xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
        var data = JSON.stringify({"accountID": localStorage.getItem("accountID"), "InstallationID": ongoingInstallationConfigurationID,"Marca": "TELEGRAM","Usuario": usuario,"Contraseña": "","Token": ""});      
        xhttp.onreadystatechange = function() {
          if (this.readyState === 4 && this.status === 200) {                
            console.log("Actualización correcta de la cuenta TELEGRAM.")          
            document.getElementById("loaderMessaging").className="loader hidden"

            document.getElementById("fieldsetRegistroTelegram").style = "display: none"
            document.getElementById("fieldsetYaRegistradoTelegram").style = "display"
            document.getElementById("divTelegramTxt").innerHTML = "¡Ya te he agregado a mi agenda!"
            document.getElementById("parrafoSaludoHelias").className = document.getElementById("parrafoSaludoHelias").className.replaceAll(" hidden", "")
          }            
          if (this.readyState === 4 && this.status !== 200) {                
            initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
          }            
        };
        xhttp.send(data);
      }
      else{
        document.getElementById("nombreUsuarioTelegram").className = "error"
        document.getElementById("nombreUsuarioTelegram").placeholder = "Debes introducir un ID de usuario"
      }
  
  }
  
  function guardarInformacionPaso(direccion){
    
    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")  
    
    document.getElementById("loaderMessaging").className="loader overlay"
  
    var notificacionesCriticas = "false"
    var notificacionesImportantes = "false"
    var notificacionesSugerencias = "false"
    var notificacionesDispositivos = "false"
    var notificacionesInformeSemanal = "false"    
    var notificacionesHorarioNoMolestar = "false"
    var horarioNoMolestarHoraDesde = document.getElementById("horaDesde").value
    var horarioNoMolestarHoraHasta = document.getElementById("horaHasta").value

    if(document.getElementById("checkboxNotificacionesCriticas").checked === true){ notificacionesCriticas = "true" }
    else{ notificacionesCriticas = "false" }

    if(document.getElementById("checkboxNotificacionesImportantes").checked === true){ notificacionesImportantes = "true" }
    else{ notificacionesImportantes = "false" }

    if(document.getElementById("checkboxNotificacionesSugerencias").checked === true){ notificacionesSugerencias = "true" }
    else{ notificacionesSugerencias = "false" }

    if(document.getElementById("checkboxNotificacionesActividadDispositivos").checked === true){ notificacionesDispositivos = "true" }
    else{ notificacionesDispositivos = "false" }

    if(document.getElementById("checkboxInformeSemanal").checked === true){ notificacionesInformeSemanal = "true" }
    else{ notificacionesInformeSemanal = "false" }

    if(document.getElementById("checkboxHorarioNoMolestar").checked === true){ notificacionesHorarioNoMolestar = "true" }
    else{ notificacionesHorarioNoMolestar = "false" }

    var email = generalCommonJS.obtenerEmailUsuario()

    if(localStorage.getItem("installationConfigurationMode") !== null){
      email = document.getElementById("emailUsuario").value
    }
    else{
      email = generalCommonJS.obtenerEmailUsuario()
    }

    var emailAlexa = document.getElementById("emailAlexa").value

    var jsonEmailing = {                  
        "email": email,
        "CriticalNotifications": notificacionesCriticas,
        "ImportantNotifications": notificacionesImportantes,
        "SuggestionsNotifications": notificacionesSugerencias,
        "DevicesNotifications": notificacionesDispositivos,
        "WeeklyReport": notificacionesInformeSemanal,
        "DontDistrubTimeframe": notificacionesHorarioNoMolestar,
        "DontDistrubTimeframeFrom": horarioNoMolestarHoraDesde,
        "DontDistrubTimeframeTo": horarioNoMolestarHoraHasta,
        "emailAlexa": emailAlexa
    }       
  
    var jsonGuardado = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": ongoingInstallationConfigurationID,
      "Messaging": jsonEmailing
    }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", updateInstallationConfiguration, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonGuardado);
      xhttp.onreadystatechange = function() {
        
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuestaGuardado = JSON.parse(this.responseText)
          if(jsonRespuestaGuardado.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{          
            console.log("Información guardada correctamente")
            
            // Y continuo a la siguiente página    
            if(localStorage.getItem("installationConfigurationMode") === null){
              if(localStorage.getItem("ongoingStepConfiguration") === "MESSAGING_USER" ){      
                initialConfigCommonJS.navegarDinamico(direccion)
              }
              else{
                initialConfigCommonJS.mostrarMensajeInformativo('Todavía no he cargado la información para continuar, me has pillado despistao, inténtalo de nuevo ahora a ver...',"")
              }
            }
            else{
              document.getElementById("asideDetalleConfiguracion").className += " hidden"
              document.getElementById("loaderMessaging").className="loader hidden"
            }
          }
        }
  
        if (this.readyState === 4 && this.status !== 200) {                          
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
        }
      }
      xhttp.send(data);    
      
  }
  
  function navegar(direccion){    
    if(initialConfigCommonJS.existeSesion()){
      if(direccion === "continuar"){    
        if(document.getElementById("contenedorPrincipalOpcion") !== null){
          document.getElementById("contenedorPrincipalOpcion").scrollTop = 0
        }
        guardarInformacionPaso(direccion)
      }
      else{
        if(localStorage.getItem("ongoingStepConfiguration") === "MESSAGING_USER"){      
          initialConfigCommonJS.navegarDinamico(direccion)
        }
        else{
          initialConfigCommonJS.mostrarMensajeInformativo('Todavía no he cargado la información para continuar, me has pillado despistao, inténtalo de nuevo ahora a ver...',"")
        }
      }
    }
  }

  function visibilidadHorarioNoMolestar(){

    if(document.getElementById("checkboxHorarioNoMolestar").checked === true){
      document.getElementById("divHorasNoMolestar").className = document.getElementById("divHorasNoMolestar").className.replaceAll(" hidden", "")
    }
    else{
      document.getElementById("divHorasNoMolestar").className = document.getElementById("divHorasNoMolestar").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("horaDesde").value = "00:00"
      document.getElementById("horaHasta").value = "00:00"
    }

    checkConfiguracionAccionado()

  }

  function checkConfiguracionAccionado(){
    
    if(localStorage.getItem("installationConfigurationMode") !== null){
      initialConfigCommonJS.mostrarMensajeInformativo("Recuerda guardar la configuración usando el botón de la parte inferior.","info")
    }
  }

  return (          
    <main id="divMainContenedorStep">      

      <InitialConfigHeader step={"MESSAGING"}/>

      <section id="messaging" className="step wrapper">
        <div id="divContenedorStep" className="content-wrapper half">

          <StepIntro 
            Title="Mensajería y Alexa" 
            Intro={<p>Te mantendré informado por email de todo lo que suceda en tu instalación.</p>}
          /> 

          <fieldset id="fieldsetEmail">            
            <div className="message success left">
              <h1 id="emailUsuarioCabecera" className="title"><span className="material-icon">email</span>{generalCommonJS.obtenerEmailUsuario()}</h1>  
            </div>
            { localStorage.getItem("installationConfigurationMode") !== null ?
              <p>Si necesitas cambiarlo, puedes hacerlo en tu cuenta de usuario pulsando <a href="/UserAccount" rel="noopener noreferrer" target="_self" className="link inline-link">aquí</a>.</p>                        
            :
              <></>
            }    
          </fieldset>

          <input type="text" id="emailUsuario" className=" hidden" />

          <fieldset className="check multiple toggle green">
            
            <input type="checkbox" id="checkboxNotificacionesCriticas" onClick={() => checkConfiguracionAccionado()} defaultChecked/>
            <label className="icon-wrapper has-tooltip" htmlFor="checkboxNotificacionesCriticas" >
              <span className="label" onClick={(event) => event.preventDefault()}>                
                <div className="content">
                  <span className="label">Sucesos críticos</span>
                  <p className="clarification size-s">Ej: Instalación sin conexión, se han ido los plomos...</p>
                </div>
              </span>              
            </label>

            <input type="checkbox" id="checkboxNotificacionesImportantes" onClick={() => checkConfiguracionAccionado()} defaultChecked/>
            <label className="icon-wrapper has-tooltip" htmlFor="checkboxNotificacionesImportantes" >
              <span className="label" onClick={(event) => event.preventDefault()}>
                <div className="content">
                  <span className="label">Sucesos importantes</span>
                  <p className="clarification size-s">Ej: Excesos de potencia, consumo máximo histórico, paneles inoperativos...</p>
                </div>
              </span>
            </label>

            <input type="checkbox" id="checkboxNotificacionesSugerencias" onClick={() => checkConfiguracionAccionado()} defaultChecked/>
            <label className="icon-wrapper has-tooltip" htmlFor="checkboxNotificacionesSugerencias" >
              <span className="label" onClick={(event) => event.preventDefault()}>
                <div className="content">
                  <span className="label">Sugerencias frente a problemas</span>
                  <p className="clarification size-s">Ej: Estás regalando tu excedente, tu subvención peligra...</p>
                </div>                
              </span>
            </label>

            <input type="checkbox" id="checkboxNotificacionesActividadDispositivos" onClick={() => checkConfiguracionAccionado()} defaultChecked/>
            <label className="icon-wrapper has-tooltip" htmlFor="checkboxNotificacionesActividadDispositivos" >
              <span className="label" onClick={(event) => event.preventDefault()}>
                <div className="content">
                  <span className="label">Actividad de dispositivos inteligentes</span>
                  <p className="clarification size-s">Ej: Dispositivo encendido, apagado, valor modificado...</p>
                </div>                
              </span>
            </label>

            <input type="checkbox" id="checkboxInformeSemanal" onClick={() => checkConfiguracionAccionado()} defaultChecked/>
            <label className="icon-wrapper has-tooltip" htmlFor="checkboxInformeSemanal" >
              <span className="label" onClick={(event) => event.preventDefault()}>
                <div className="content">
                  <span className="label">Informe semanal</span>
                  <p className="clarification size-s">Informe económico básico semanal de tu instalación.</p>
                </div>                
              </span>
            </label>

            <input type="checkbox" id="checkboxInformeMensual" className=" hidden" onClick={() => checkConfiguracionAccionado()} defaultChecked/>
            <label className="icon-wrapper has-tooltip hidden" htmlFor="checkboxInformeMensual" >
              <span className="label" onClick={(event) => event.preventDefault()}>
                <div className="content">
                  <span className="label">Informe mensual</span>
                  <p className="clarification size-s">Informe económico detallado mensual con observaciones sobre tu instalación.</p>
                </div>                
              </span>
            </label>

          </fieldset>


          <fieldset className="check multiple toggle green expandable">
            
            <div className="toggle-container">
              <input type="checkbox" id="checkboxHorarioNoMolestar" onClick={() => visibilidadHorarioNoMolestar()}/>
              <label className="icon-wrapper has-tooltip" htmlFor="checkboxHorarioNoMolestar" >
                <span className="label" >
                  <div className="content">
                    <span className="label">Horario de no molestar</span>
                    <p className="clarification size-s">Si hay alguna franja horaria en la que, pase lo que pase, no quieres que te moleste, activa esta opción e indica el horario.</p>
                  </div>                
                </span>            
              </label>
            </div>

            <div id="divHorasNoMolestar" className="toggle-additional-content horizontal gap-04 hidden">
              
              <div className="col">
                <fieldset className="time">
                  <label htmlFor="labelHoraDesde"><b>Desde</b></label>		
                  <div className="icon-wrapper">
                    <input type="time" id="horaDesde" name="horaDesde" min="00:00" max="23:59" defaultValue="00:00"/>
                  </div>
                </fieldset>
              </div>
                            
              <div className="col">
                <fieldset className="time">
                  <label htmlFor="labelHoraHasta"><b>Hasta</b></label>		
                  <div className="icon-wrapper">
                    <input type="time" id="horaHasta" name="horaHasta" min="00:00" max="23:59" defaultValue="00:00"/>
                  </div>
                </fieldset>
              </div>
                
            </div>            
                
          </fieldset>

          <fieldset className="tooltip-parent">

            <div className="message info left">
              <div className="horizontal">
                
                
                <fieldset id="fieldsetEmailAlexa" className="vertical fill">
                  <fieldset className="horizontal gap-02 vertical-end">
                    <fieldset className="fill" style={{marginTop: "-15px"}}>
                      <label className="has-tooltip" htmlFor="nombreEmailAlexa">
                        <span className="label tooltip-label">E-Mail de Alexa para esta instalación:</span>
                        <span className="tooltip-trigger">
                        <span className="material-icon tooltip-icon link size-s">info</span>
                          <span className="tooltip bottom">
                            <span className="tooltip-container">
                              <p className="size-m tooltip-title">¿E-Mail de Alexa?</p>
                              <p className="size-s">Es el email con el que usas Alexa en esta instalación. <strong>Si no lo indicas no podrás utilizar la skill de Alexa de Helias</strong>.</p>
                            </span>
                          </span>
                        </span>
                      </label>
                      
                      <input type="text" id="emailAlexa"/>

                  

                    </fieldset>

                  </fieldset>              

                  <p className="size-s">Pulsa <a href="https://www.amazon.es/dp/B0F5WJ21D5" className="link inline-link" target="_blank" rel="noopener noreferrer" title="Alexa skill"> aquí para instalar la skill de Helias en Alexa</a> y recuerda darle los permisos necesarios.</p>
                </fieldset>

                

              </div>
              
            </div>

            
          </fieldset>


          <fieldset className="two-columns tooltip-parent hidden">
            <fieldset id="fieldsetRegistroTelegram">
              <fieldset className="horizontal gap-02 vertical-end">
                <fieldset className="fill">
                  <label className="has-tooltip" htmlFor="nombreUsuarioTelegram">
                    <span className="label tooltip-label">ID usuario Telegram</span>
                    <span className="tooltip-trigger">
                    <span className="material-icon tooltip-icon link size-s">info</span>
                      <span className="tooltip bottom">
                        <span className="tooltip-container">
                          <p className="size-m tooltip-title">¿Dónde encuentro mi ID de usuario Telegram?</p>
                          <p className="size-s">Para saber tu ID, abre la aplicación de Telegram y ve a Ajustes → Editar → Nombre de usuario.</p>                          
                        </span>
                      </span>
                    </span>
                  </label>

                  <input type="text" id="nombreUsuarioTelegram" onClick={() => document.getElementById("nombreUsuarioTelegram").className = ""}/>
                </fieldset>

                <button className="button primary hug" onClick={() => registrarUsuarioTELEGRAM()}>Añádeme</button>
              </fieldset>              
            </fieldset>

            <fieldset id="fieldsetYaRegistradoTelegram" style={{display: "none"}}>     

              <div id="divYaRegistradoTelegram" className="message success left">
                <h1 className="title">
                  <span className="material-icon">telegram</span>
                  <div id="divTelegramTxt" className="fill"></div>                  
                  <button className="material-icon delete link" onClick={() => initialConfigCommonJS.borrarAplicacion("TELEGRAM", "", ReactGA)}>remove_circle</button> 
                </h1>   
                
                <p id="parrafoSaludoHelias" className=" hidden">Ahora búscame en Telegram <span className="strong">(@Helias_bot)</span> y escríbeme. Me vale un simple “Hola” para reconocerte 😊, aunque puede que tarde en contestarte hasta 1 minuto. Con esto ya podré enviarte mensajes...</p>
                          
              </div>              
              
            </fieldset>
          </fieldset>

          <WorkflowNavigationButtons step={"MESSAGING"} navegar={navegar}/>

        </div>

        { localStorage.getItem("installationConfigurationMode") === null
          ? <WorkflowIlustration illustrationElements={illustrationElements}/>
          : <></>
        }

        <Loader Id="loaderMessaging" Mensaje=""/>

      </section>

    </main>
    
  )
}

export default Messaging